export type Facets = {
  attributes: { id: string; name: string; values: string[] }[];
  suppliers?: { name: string }[];
  brands?: { name: string }[];
  productTags?: { id: string; name: string }[];
  customFields?: { name: string; values: string[] }[];
};

export type Attribute = {
  id: string;
  name: string;
  values: string[];
};

export type Brand = {
  id: string;
  name: string;
};

export type ProductTag = {
  id: string;
  name: string;
};

export interface ProductSearchContent {
  offerPrice: OfferPriceSearch;
  offer: OfferSearch;
  variant: VariantSearch;
  product: ProductSearch;
  attributes: AttributeSearch[];
  supplier: SupplierSearch;
}

export enum AggregationType {
  PRODUCT = 'PRODUCT',
  VARIANT = 'VARIANT',
}
export interface OfferPriceSearch {
  id: string;
  externalId: string;
  offerPriceType: string | null;
  itemPerPack: number;
  price: number;
  unitPriceTTC: number;
  itemPrice: number;
  unitPrice: number;
  discountItemPrice: number | null;
  discountUnitPrice: number | null;
}

export interface OfferSearch {
  id: string;
  externalId: string;
  quantityPerItem: number;
  stock: number;
  currency: string;
  packingType: string | null;
  productUnit: string | null;
  maxOrderQuantity: number | null;
  minOrderQuantity: number;
  minStockAlert: number;
  minShippingPrice: number;
  leadTimeToShip: number | null;
  customFields: any[];
}

export interface VariantSearch {
  id: string;
  externalId: string;
  sku: string;
  name: string;
  description: string | null;
  pictureUrls: PictureUrl[];
  ean: string;
  mpn: string | null;
}

export interface PictureUrl {
  widthInPx: number;
  heightInPx: number;
  formatType: string;
  sizeType: string;
  url: string;
  main: boolean;
}

export interface ProductSearch {
  id: string;
  externalId: string;
  sku: string;
  name: string;
  description: string | null;
  brand: string | null;
  mainPictureUrl: string | null;
  tags: any[];
  unit: string | null;
}

export interface AttributeSearch {
  name: string;
  externalId: string;
  value: string;
  values: string[];
}

export interface SupplierSearch {
  id: string;
  name: string;
  externalId: string;
}
